import * as R from "ramda";
import * as React from "react";
import * as Autosuggest from "react-autosuggest";
import { FaRegClone } from "react-icons/fa";
import { connect } from "react-redux";
import styled from "styled-components";
import {
  CustomSearchInput,
  FooterNote,
  SearchField,
  SetupButton,
} from "../../../../App/Common/Components/FormComponents";
import { Section, SectionTitle } from "../../../../App/Common/Styles/containers";
import { IState } from "../../../../App/reducer";
import { IOrganization } from "../../../../reducers/course-author/types";
import { contains } from "../../../../utils";
import { ICourseEditOperations, IFullCourse } from "../../../course-author/types";
import AutoComplete from "../Autocomplete";

const CloneIcon = styled(FaRegClone)`
  margin: 0 0.5rem;
`;

const Buttons = styled.div`
  margin: 1rem 0;
  width: 22.5rem;
`;

export interface ICourseCloneStateProps {
  organizations: IOrganization[];
}

export interface ICourseCloneOwnProps {
  course: IFullCourse;
  editOperations: ICourseEditOperations;
  userId: string;
}

export interface ICourseCloneState {
  selectOrganization: string;
  selected: string;
}

export type ICourseCloneProps = ICourseCloneOwnProps & ICourseCloneStateProps;

const chooseOrgForClone = "choose-org-for-clone";

export class CloneCourse extends React.Component<ICourseCloneProps, ICourseCloneState> {
  constructor(props: ICourseCloneProps) {
    super(props);
    this.state = {
      selectOrganization: "",
      selected: this.props.course.state.owner,
    };
  }

  public onSuggestionsFetchRequested = ({ value }: Autosuggest.SuggestionsFetchRequestedParams) =>
    this.setState({ selectOrganization: value });

  public selectNewOrg = (suggestion: IOrganization) => this.setState({ selected: suggestion.organizationId });

  public cloneCourse = () => {
    this.props.editOperations.cloneCourseIntoOrg(this.state.selected);
  };

  public render() {
    const suggestOrgs = this.props.organizations.filter(org =>
      contains(this.state.selectOrganization, org.displayName)
    );

    return (
      <Section>
        <SectionTitle>Course Cloning</SectionTitle>
        <SearchField legend={"Organisation name"}>
          <AutoComplete
            fetchSuggestions={this.onSuggestionsFetchRequested}
            htmlName={chooseOrgForClone}
            items={suggestOrgs}
            itemValue={R.propOr("", "displayName")}
            placeholderText={"Type here"}
            renderInputComponent={CustomSearchInput}
            setSelected={this.selectNewOrg}
          />
        </SearchField>
        <Buttons>
          <SetupButton onClick={this.cloneCourse}>
            <CloneIcon /> Clone to selected organisation
          </SetupButton>
        </Buttons>
        <FooterNote>Note: You will navigate to the Course list once the course is cloned.</FooterNote>
      </Section>
    );
  }
}

export default connect<ICourseCloneStateProps, {}, ICourseCloneOwnProps, IState>((state, props) => ({
  organizations: state.App.CourseAuthor._.organizations || [],
}))(CloneCourse);
